<template>

    <div v-if="nIconId===1" class="display-flex justify-content-center">
        <div v-if="iconType==='den'" :class="iconClass">
            <div class="shmu-icon sunny">
                <div class="sun-group">
                    <img src="static/shmu/img/svg/sun2.svg" alt="" class="shine">
                    <img src="static/shmu/img/svg/sun1.svg" alt="" class="sun">
                </div>
            </div>
        </div>
        <div v-else :class="iconClass">
            <div class="shmu-icon night">
                <img src="static/shmu/img/svg/moon.svg" alt="" class="moon">
                <img src="static/shmu/img/svg/star.svg" alt="" class="star">
                <img src="static/shmu/img/svg/star.svg" alt="" class="star">
            </div>
        </div>
    </div>
    <div v-else-if="nIconId===2" class="display-flex justify-content-center">
        <div v-if="iconType==='den'" :class="iconClass">
            <div class="shmu-icon mostly_sunny">
                <div class="sun-group">
                    <img src="static/shmu/img/svg/sun2.svg" alt="" class="shine">
                    <img src="static/shmu/img/svg/sun1.svg" alt="" class="sun">
                </div>
                <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud1">
            </div>
        </div>
        <div v-else :class="iconClass">
            <div class="shmu-icon night">
                <img src="static/shmu/img/svg/moon.svg" alt="" class="moon">
                <img src="static/shmu/img/svg/star.svg" alt="" class="star">
                <img src="static/shmu/img/svg/star.svg" alt="" class="star">
                <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud1">
            </div>
        </div>
    </div>
    <div v-else-if="nIconId===3" class="display-flex justify-content-center">
        <div v-if="iconType==='den'" :class="iconClass">
            <div class="shmu-icon partly_cloudy">
                <div class="sun-group">
                    <img src="static/shmu/img/svg/sun2.svg" alt="" class="shine">
                    <img src="static/shmu/img/svg/sun1.svg" alt="" class="sun">
                </div>
                <img src="static/shmu/img/svg/cloud2.svg" alt="" class="cloud2">
                <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud1">
            </div>
        </div>
        <div v-else :class="iconClass">
            <div class="shmu-icon partly_cloudy">
                <div class="shmu-icon night_partly_cloudy">
                    <img src="static/shmu/img/svg/moon.svg" alt="" class="moon">
                    <img src="static/shmu/img/svg/star.svg" alt="" class="star">
                    <img src="static/shmu/img/svg/star.svg" alt="" class="star">
                    <img src="static/shmu/img/svg/cloud2.svg" alt="" class="cloud2">
                    <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud1">
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="nIconId===4" class="display-flex justify-content-center">
        <div :class="iconClass">
            <div class="shmu-icon cloudy" :class="iconClass">
                <div class="cloud-group">
                    <img src="static/shmu/img/svg/cloud2.svg" alt="" class="cloud2">
                    <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud3">
                    <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud1">
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="nIconId===5" class="display-flex justify-content-center">
        <div :class="iconClass">
            <div class="shmu-icon cloudsOnTop misty">
                <div class="cloud-group">
                    <img src="static/shmu/img/svg/cloud2.svg" alt="" class="cloud2">
                    <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud1">
                </div>
                <img src="static/shmu/img/svg/mist.svg" alt="" class="mist">
                <img src="static/shmu/img/svg/mist.svg" alt="" class="mist">
                <img src="static/shmu/img/svg/mist.svg" alt="" class="mist">
            </div>
        </div>
    </div>
    <div v-else-if="nIconId===6" class="display-flex justify-content-center">
        <div :class="iconClass">
            <div class="shmu-icon cloudsOnTop drizzle">
                <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position1">
                <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position2">
                <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position3">
                <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position4">
                <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position5">
                <div class="cloud-group">
                    <img src="static/shmu/img/svg/cloud2.svg" alt="" class="cloud2 ">
                    <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud1 ">
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="nIconId===7" class="display-flex justify-content-center">
        <div :class="iconClass">
            <div class="shmu-icon cloudsOnTop raining">
                <div class="drop-group">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position1">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position2">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position3">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position4">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position5">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position6">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position7">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position8">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position9">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain2 position10">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain2 position11">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain2 position12">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain2 position13">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain2 position14">
                </div>
                <div class="cloud-group">
                    <img src="static/shmu/img/svg/cloud2.svg" alt="" class="cloud2 ">
                    <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud3 ">
                    <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud1 ">
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="nIconId===8" class="display-flex justify-content-center">
        <div :class="iconClass">
            <div class="shmu-icon cloudsOnTop raining_snowing">
                <div class="flake-group">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position4">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position5 smaller">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position7">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position8 smaller">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position9">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow2 position12">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow2 position13 smaller">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow2 position14">
                </div>
                <div class="drop-group">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position1">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position2">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position3">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position6">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position7">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain2 position10 smaller">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain2 position11">
                </div>
                <div class="cloud-group">
                    <img src="static/shmu/img/svg/cloud2.svg" alt="" class="cloud2 ">
                    <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud3 ">
                    <img src="static/shmu/img/svg/cloud3.svg" alt="" class="cloud1 ">
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="nIconId===9" class="display-flex justify-content-center">
        <div :class="iconClass">
            <div class="shmu-icon cloudsOnTop snowing">
                <div class="flake-group">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position1 smaller">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position2">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position4">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position5 smaller">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position6">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position7">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position8 smaller">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position9">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow2 position10 smaller">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow2 position11">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow2 position12">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow2 position13 smaller">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow2 position14">
                </div>
                <div class="cloud-group">
                    <img src="static/shmu/img/svg/cloud2.svg" alt="" class="cloud2 ">
                    <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud3 ">
                    <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud1 ">
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="nIconId===10" class="display-flex justify-content-center">
        <div :class="iconClass">
            <div class="shmu-icon cloudsOnTop snow_drizzle">
                <div class="flake-group">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position2 smaller">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position4">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position6">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position9">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow2 position11">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow2 position12 smaller">
                    <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow2 position14">
                </div>
                <div class="cloud-group">
                    <img src="static/shmu/img/svg/cloud2.svg" alt="" class="cloud2 ">
                    <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud1 ">
                </div>
            </div>

        </div>
    </div>
    <div v-else-if="nIconId===11" class="display-flex justify-content-center">
        <div :class="iconClass">
            <div v-if="iconType==='den'" :class="iconClass">
                <div class="shmu-icon cloudsOnTop sunny_raining">
                    <div class="sun-group">
                        <img src="static/shmu/img/svg/sun2.svg" alt="" class="shine">
                        <img src="static/shmu/img/svg/sun1.svg" alt="" class="sun">
                    </div>
                    <div class="drop-group">
                        <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position1">
                        <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position2">
                        <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position6">
                        <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain2 position10">
                        <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain2 position11">
                    </div>
                    <div class="cloud-group">
                        <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud1 ">
                    </div>
                </div>
            </div>
            <div v-else :class="iconClass">
                <div class="shmu-icon cloudsOnTop night_raining">
                    <img src="static/shmu/img/svg/moon.svg" alt="" class="moon">
                    <img src="static/shmu/img/svg/star.svg" alt="" class="star">
                    <img src="static/shmu/img/svg/star.svg" alt="" class="star">
                    <div class="drop-group">
                        <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position1">
                        <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position2">
                        <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position6">
                        <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain2 position10">
                        <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain2 position11">
                    </div>
                    <div class="cloud-group">
                        <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud1 ">
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div v-else-if="nIconId===12" class="display-flex justify-content-center">
        <div :class="iconClass">
            <div v-if="iconType==='den'" :class="iconClass">
                <div class="shmu-icon cloudsOnTop sunny_snowing">
                    <div class="sun-group">
                        <img src="static/shmu/img/svg/sun2.svg" alt="" class="shine">
                        <img src="static/shmu/img/svg/sun1.svg" alt="" class="sun">
                    </div>
                    <div class="flake-group">
                        <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position1 smaller">
                        <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position2">
                        <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position6">
                        <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position7">
                        <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow2 position10 smaller">
                        <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow2 position11">
                    </div>
                    <div class="cloud-group">
                        <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud1 ">
                    </div>
                </div>
            </div>
            <div v-else :class="iconClass">
                <div class="shmu-icon cloudsOnTop night_snowing">
                    <img src="static/shmu/img/svg/moon.svg" alt="" class="moon">
                    <img src="static/shmu/img/svg/star.svg" alt="" class="star">
                    <img src="static/shmu/img/svg/star.svg" alt="" class="star">
                    <div class="flake-group">
                        <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position1 smaller">
                        <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position2">
                        <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position6">
                        <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow1 position7">
                        <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow2 position10 smaller">
                        <img src="static/shmu/img/svg/flake.svg" alt="" class="flake snow2 position11">
                    </div>
                    <div class="cloud-group">
                        <img src="static/shmu/img/svg/cloud1.svg" alt="" class="cloud1 static">
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div v-else-if="nIconId===13" class="display-flex justify-content-center">
        <div :class="iconClass">
            <div class="shmu-icon cloudsOnTop thunder">
                <div class="drop-group">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position1">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position2">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position3">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position4">
                    <img src="static/shmu/img/svg/drop.svg" alt="" class="drop rain1 position5">
                </div>
                <div class="flash-group">
                    <img src="static/shmu/img/svg/flash.svg" alt="" class="storm1 position15">
                    <img src="static/shmu/img/svg/flash.svg" alt="" class="storm3 position17">
                </div>
                <div class="cloud-group">
                    <img src="static/shmu/img/svg/cloud4.svg" alt="" class="cloud1 static">
                    <img src="static/shmu/img/svg/cloud4.svg" alt="" class="cloud2">
                    <img src="static/shmu/img/svg/cloud3.svg" alt="" class="cloud1">
                </div>
            </div>

        </div>
    </div>
    <div v-else-if="nIconId===14" class="display-flex justify-content-center">
        <div :class="iconClass">
            <div class="shmu-icon cloudsOnTop lightning">
                <div class="flash-group">
                    <img src="static/shmu/img/svg/flash.svg" alt="" class="storm1 position15">
                    <img src="static/shmu/img/svg/flash.svg" alt="" class="storm2 position16">
                    <img src="static/shmu/img/svg/flash.svg" alt="" class="storm3 position17">
                </div>
                <div class="cloud-group">
                    <img src="static/shmu/img/svg/cloud4.svg" alt="" class="cloud2">
                    <img src="static/shmu/img/svg/cloud3.svg" alt="" class="cloud1">
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import '../static/shmu/css/shmu-icons.css';

    export default {
        name: 'shmu-icon',
        props: [
            'iconId',
            'iconType',
            'iconClass',
        ],
        computed: {
            nIconId: function() {
                return parseInt(this.iconId)
            }
        }
    }

</script>

